import { FormattedText, Modal, Typography } from 'src/modules/core/components'
import classes from './auto-reminder-modal.module.scss'

export interface AutoReminderModalProps {
  open: boolean
  onClose: () => void
}

export function AutoReminderModal({ open, onClose }: AutoReminderModalProps) {
  if (!open) {
    return null
  }

  return (
    <Modal
      variant="primary"
      closeOnBackdropClick={false}
      onClose={onClose}
      title={
        <Typography variant="h3" className={classes.modalTitle}>
          <FormattedText id="autoRemindersModal.title" />
        </Typography>
      }
    >
      <div className={classes.root}>
        <p>
          <FormattedText id="autoRemindersModal.lead" />
        </p>
        <p>
          <FormattedText id="autoRemindersModal.text" />
        </p>
        <div className={classes.box}>
          <h3>
            <FormattedText id="autoRemindersModal.eventTitle.title" />
          </h3>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/recordatorio-de-cita.appspot.com/o/auto-reminders-title.jpg?alt=media&token=39b403f7-6423-46fb-8bbd-e2c26f7af645"
            alt="Auto Reminders in the Event Title"
          />
        </div>
        <div className={classes.box}>
          <h3>
            <FormattedText id="autoRemindersModal.eventDescription.title" />
          </h3>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/recordatorio-de-cita.appspot.com/o/auto-reminders-description.jpg?alt=media&token=be64bcce-832c-40e6-b5fe-38dad286f3a2"
            alt="Auto Reminders in the Event Description"
          />
          <p>
            <FormattedText id="autoRemindersModal.eventDescription.text" />
          </p>
        </div>
      </div>
    </Modal>
  )
}
